import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import { useTranslation } from 'react-i18next'

import API from '../../../../../api/api'
import { selectUserData } from '../../../../../reducers/userDataReducer'

import FormInput from './FormInput'
import SelectInput from './SelectInput'

const inputName = 'mainClient'
const columnSize = 6

const ClientInput = ({ mainClient, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])
  const label = t('eventManagement:common.selectClientLabel')
  const placeholder = t('eventManagement:common.selectClientPlaceholder')
  const userData = useSelector(selectUserData)
  const isManagerOrAdmin = ['Manager', 'Administrator'].includes(userData.user.role)
  const userClients = useMemo(() => {
    return (userData.clients || []).map((option) => ({
      value: option.id,
      label: option.user?.firstName + ' ' + option.user?.lastName,
    }))
  }, [userData])

  const debouncedLoadClientOptions = debounce(async (value, callback) => {
    const response = await API.getClients(0, 100, 0, 0, value)
    const data = response.map((c) => ({
      value: c.id,
      label: `${c.user.firstName} ${c.user.lastName}`,
    }))

    callback(data)
  }, 500)

  const loadClientOptions = (inputValue) => {
    return new Promise((resolve) => {
      debouncedLoadClientOptions(inputValue, resolve)
    })
  }

  if (isManagerOrAdmin) {
    return (
      <div className={`column is-${columnSize}`}>
        <FormInput label={label} name={inputName}>
          <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={loadClientOptions}
            placeholder={placeholder}
            value={mainClient}
            onChange={(e) => {
              setFieldValue(inputName, e)
            }}
          />
        </FormInput>
      </div>
    )
  }

  return (
    <SelectInput
      columnSize={columnSize}
      name={inputName}
      label={label}
      placeholder={placeholder}
      options={userClients}
      value={mainClient}
      setFieldValue={setFieldValue}
    />
  )
}

ClientInput.propTypes = {
  mainClient: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
}

export default ClientInput
